import { Component, Input } from "@angular/core";
import { PerfTableColumn } from "../card-types";

@Component({
  selector: "perf-table",
  templateUrl: "./perf-table.component.html",
  styleUrls: ["../../dashboard-section.scss", "../../dashboard-section-v2.scss"],
  styles: [":host { display: contents; }"],
})
export class PerfTableComponent {
  @Input() rows: any[] = [];
  @Input() nameColumn: PerfTableColumn;
  @Input() valueColumns: PerfTableColumn[] = [];
  @Input() showHeader: boolean = true;
  @Input() rowLimit: number;
  @Input() extraClass: string = "";

  trackByIndex(index: number): number {
    return index;
  }
}
